export const STATUS_MAP = {
	complete: 'CHECKED',
	incomplete: 'UNCHECKED',
} as const;

export type TasksReportStatus = keyof typeof STATUS_MAP;

const DEFAULT_STATUS: TasksReportStatus = 'incomplete';

const STATUS_ALIASES: Record<string, TasksReportStatus> = {
	complete: 'complete',
	completed: 'complete',
	checked: 'complete',
	incomplete: 'incomplete',
	unchecked: 'incomplete',
};

export const normalizeTasksReportStatus = (rawStatus: string | undefined): TasksReportStatus => {
	const normalizedStatus = rawStatus?.trim().toLowerCase();
	if (!normalizedStatus) {
		return DEFAULT_STATUS;
	}

	return STATUS_ALIASES[normalizedStatus] ?? DEFAULT_STATUS;
};
